import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const Series = () => {
    document.title = "Seriya";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Seriya", value: "/products/[arameters/series", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Seriya</h2>
                    <p>
                        Bir məhsulun müxtəlif seriya nömrələri ilə alışı və satışı üçün nəzərdə tutulub. Məhsulun seriya nömrəsi unikaldır (təkrarlanmır).{" "}
                        <Link to={""}>Alış</Link> zamanı məhsulun seriya nömrəsi qeyd edilməlidir. <Link to={""}>Satış</Link> zamanı seriyalı məhsulun seriyası
                        qeyd edilməlidir.
                    </p>
                    <img src="/images/products/parameters/#.gif" alt="Seriya" />
                </article>
            </div>
        </div>
    );
};
